
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M60 14.2c25.252 0 45.8 20.548 45.8 45.8S85.252 105.8 60 105.8 14.2 85.252 14.2 60 34.748 14.2 60 14.2Z",
  fill: "var(--theme-light, #f9f3fb)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.284 9.437a1.208 1.208 0 0 0 .026 1.711l6.01 5.844-5.844 6.023a1.208 1.208 0 0 0 .026 1.71c.48.467 1.244.455 1.71-.025l5.845-6.023 6.022 5.845c.48.466 1.245.454 1.71-.026a1.208 1.208 0 0 0-.025-1.71l-6.022-5.845 5.844-6.022a1.208 1.208 0 0 0-.026-1.711 1.208 1.208 0 0 0-1.71.025l-5.845 6.023-6.022-5.844a1.216 1.216 0 0 0-1.699.025z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 34 34\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M60 14.2002C85.2517 14.2002 105.8 34.7483 105.8 60C105.8 85.2517 85.2517 105.8 60 105.8C34.7483 105.8 14.2002 85.2517 14.2002 60C14.2002 34.7483 34.7483 14.2002 60 14.2002Z\" fill=\"var(--theme-light, #f9f3fb)\" stroke-width=\"4.4\"></path>  \r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.284 9.437a1.208 1.208 0 0 0 .026 1.711l6.01 5.844-5.844 6.023a1.208 1.208 0 0 0 .026 1.71c.48.467 1.244.455 1.71-.025l5.845-6.023 6.022 5.845c.48.466 1.245.454 1.71-.026a1.208 1.208 0 0 0-.025-1.71l-6.022-5.845 5.844-6.022a1.208 1.208 0 0 0-.026-1.711 1.208 1.208 0 0 0-1.71.025l-5.845 6.023-6.022-5.844a1.216 1.216 0 0 0-1.699.025z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/close-icon.44069164ed28b9f230abf2d96f7cd881.svg"),
        {
          React: SvgCloseIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      